<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-card"></i>
        <div class="mg-l-20">
          <h4>{{ $t("financial.对账单管理") }}</h4>
        </div>
      </div>
      <div class="tx-right" v-if="isSysRights('Bill.exportBySupplier')">
        <a
          v-if="check_items > 0"
          href="javascript:;"
          class="btn btn-primary"
          @click="exportBill('1')"
          >{{ $t("financial.导出选中的对账单") }}({{ check_items }})</a
        >
        <a
          v-if="check_items == 0"
          href="javascript:;"
          class="btn"
          :class="active ? 'btn-primary' : 'btn-outline-secondary'"
          @click="exportBill('2')"
          >{{ $t("financial.导出符合条件的对账单") }}</a
        >
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30"
    >
      <div class="clear-key">
        <a
          v-show="supplier_name"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('name')"
        >
          {{ $t("financial.供应商名：") }}
          <span class="mg-r-10">{{ supplier_name }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="batchBool"
          @click="clearKey('batchBool')"
          href="javascript:;"
          class="mg-r-15"
        >
          {{ $t("distributor.批量搜索") }}
          
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="supplier_contacts"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('contacts')"
        >
          {{ $t("financial.联系方式：") }}
          <span class="mg-r-10">{{ supplier_contacts }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="bill_code"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('billCode')"
        >
          {{ $t("financial.对账单编号：") }}
          <span class="mg-r-10">{{ bill_code }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="order_code"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('code')"
        >
          {{ $t("financial.采购单号：") }}
          <span class="mg-r-10">{{ order_code }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="settlement_status"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('status')"
        >
          {{ $t("financial.结算状态：") }}
          <span class="mg-r-10">{{
            $t(billStatusArr[settlement_status])
          }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="key_type"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('type')"
        >
          {{ $t("financial.结算类型：") }}
          <span class="mg-r-10">{{ $t($dict.billType[key_type]) }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="key_hasSubBill"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('hasSubBill')"
        >
          {{ $t("financial.是否只显示有子对账单") }}:
          <span class="mg-r-10">{{ billStatusBrr[key_hasSubBill] }}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "bill_code",
    "order_code",
    "settlement_status",
    "supplier_name",
    "supplier_contacts",
    "check_arr",
    "key_type",
    "check_items",
    "key_hasSubBill",
    "batchBool"
  ],
  data() {
    return {
      billStatusArr: arrDict.billStatus,
      billStatusBrr: {
        1: this.$t("mall.是"),
        2: this.$t("mall.否"),
      },
    };
  },
  computed: {
    active() {
      return this.code ||
        this.audit ||
        this.order_code ||
        this.settlement_status ||
        this.supplier_name ||
        this.supplier_contacts ||
        this.key_type
        ? true
        : false;
    },
  },
  methods: {
    clearKey(type) {
      this.$emit("clearKey", type, this.active);
    },
    exportBill(type) {
      this.$emit("exportBill", type, this.active);
    },
  },
};
</script>
